import { render, staticRenderFns } from "./examinationMessage.vue?vue&type=template&id=1d6fb0fc&scoped=true"
import script from "./examinationMessage.vue?vue&type=script&lang=js"
export * from "./examinationMessage.vue?vue&type=script&lang=js"
import style0 from "./examinationMessage.vue?vue&type=style&index=0&id=1d6fb0fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6fb0fc",
  null
  
)

export default component.exports